import { Injectable } from '@angular/core';
import { Record } from '@common/data-models/records/record';
import { IFieldMappingService } from '@common/interfaces/i-field-mapping-service';
import { Util } from '@common/utils/util';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { GlobalTablesService } from './global-tables-service';

@Injectable({ providedIn: 'root' })
export class FieldMappingService implements IFieldMappingService {
    public parentChildDictionary: { [number: string]: number } = {};

    constructor(public globalTablesService: GlobalTablesService) {
        this.parentChildDictionary[ObjectTypes.TOPIC] = ObjectTypes.ASSIGNMENT;

        Record.fieldMappingService = this;
    }

    private checkValidationTypes(sourceId: string, destinationId: string): boolean {
        const sourceField = this.globalTablesService.FieldDefsDict[sourceId];
        const destinationField = this.globalTablesService.FieldDefsDict[destinationId];
        let sourceFieldValidation: string = '';
        let destinationFieldValidation: string = '';

        if (sourceField) {
            sourceFieldValidation = sourceField.Validation.toUpperCase();
        }
        if (destinationField) {
            destinationFieldValidation = destinationField.Validation.toUpperCase();
        }
        if (sourceId === 'Title' || sourceId === 'ENPSText' || sourceId === 'ENPSTextBBL') {
            sourceFieldValidation = 'TEXT';
        }
        if (destinationId === 'Title' || destinationId === 'ENPSText' || destinationId === 'ENPSTextBBL') {
            destinationFieldValidation = 'TEXT';
        }
        return sourceFieldValidation === destinationFieldValidation;
    }

    private getFieldMappingRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.globalTablesService.FieldMappings.filter((rule: FieldMapping) => rule.SourceObjectType === sourceType && rule.DestinationObjectType === destinationType);
    }

    private getCopyToChildRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.getFieldMappingRules(sourceType, destinationType).filter((rule: FieldMapping) => rule.CopyToChild);
    }

    private getUpdateToChildRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.getFieldMappingRules(sourceType, destinationType).filter((rule: FieldMapping) => rule.UpdateToChild);
    }

    public updateToChild(parent: StorytellingCollectionRecord, field: string, value: any) {
        const parentType = parent.Type;
        const childType = this.parentChildDictionary[parent.Type];
        if (parentType && childType) {
            const fieldMappingRules = this.getUpdateToChildRules(parentType, childType).filter((rule: FieldMapping) => rule.SourceFieldId === field);
            for (const rule of fieldMappingRules) {
                if (this.checkValidationTypes(rule.SourceFieldId, rule.DestinationFieldId)) {
                    for (const child of parent.children) {
                        const childValue = Util.deepCopy(value);
                        child[rule.DestinationFieldId] = childValue;
                    }
                }
            }
        }
    }

    public copyToChild(parent: StorytellingCollectionRecord, child: StorytellingRecord) {
        const fieldMappingRules = this.getCopyToChildRules(parent.Type, child.Type);
        for (const rule of fieldMappingRules) {
            if (this.checkValidationTypes(rule.SourceFieldId, rule.DestinationFieldId)) {
                const value = Util.deepCopy(parent?.[rule.SourceFieldId]);
                if (value) {
                    child[rule.DestinationFieldId] = value;
                }
            }
        }
    }

    public copyToChildV2(parent: StorytellingCollectionRecord, child: StorytellingRecord) {
        const fieldMappingRules = this.getCopyToChildRules(parent.Type, child.Type);
        for (const rule of fieldMappingRules) {
            if (this.checkValidationTypes(rule.SourceFieldId, rule.DestinationFieldId)) {
                const value = Util.deepCopy(parent[rule.SourceFieldId]);
                if (value) {
                    child[rule.DestinationFieldId] = value;
                }
            }
        }
    }
}
